import { render, staticRenderFns } from "./CampaignPopupTable.vue?vue&type=template&id=264fba32&"
import script from "./CampaignPopupTable.vue?vue&type=script&lang=js&"
export * from "./CampaignPopupTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPopupTable.vue?vue&type=style&index=0&id=264fba32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports